import { bool, func } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
	toggleAllInstagramInfluencerList,
	toggleInstagramInfluencer
} from '@store/actions/trend-research/TrendResearchAction';
import { useSelectedInluencers } from '@store/reducers/trend-research/TrendResearchReducer';

const BrandFilterLeftSidePanel = ({ isShowFilter, toggleIsShowFilter, influencerList }) => {
	const [influencers, setInfluencers] = useState([]);
	const [search, setSearch] = useState('');
	const selectedInfluencers = useSelectedInluencers();
	const dispatch = useDispatch();

	const handleSearch = (e) => {
		e.preventDefault();
		setSearch(e.target.value);
	};

	useEffect(() => {
		if (search) {
			let filteredList = influencerList.filter(
				(item) => item.userName.toLowerCase().indexOf(search.toLowerCase()) !== -1
			);
			setInfluencers(filteredList);
		} else {
			setInfluencers(influencerList);
		}
	}, [search, influencerList]);

	const toggleInfluencerSelection = (userName) => {
		dispatch(toggleInstagramInfluencer(userName));
	};

	const renderInfluencers = () => {
		return influencers?.map((item) => {
			return (
				<React.Fragment key={`instagram_${item.userName}`}>
					<div className="form-group group-brand-checkbox">
						<input
							type="checkbox"
							id={`instagram_${item.userName}`}
							name={`instagram_${item.userName}`}
							checked={selectedInfluencers.includes(item.userName)}
							onChange={() => toggleInfluencerSelection(item.userName)}
						/>
						<label className="regular-14 gray_dark_05" htmlFor={`instagram_${item.userName}`}>
							<span>{item.userName}</span>
						</label>
					</div>
				</React.Fragment>
			);
		});
	};

	const toggleAllInfluencers = () => {
		if (selectedInfluencers.length === influencerList.length) {
			dispatch(toggleAllInstagramInfluencerList([]));
		} else {
			dispatch(toggleAllInstagramInfluencerList(influencerList.map((item) => item.userName)));
		}
	};

	return (
		<div className={`brand-sidebar shadow-12dp ${isShowFilter ? 'active' : ''}`}>
			<div className="sidebar-header d-flex justify-content-between align-items-center">
				<p className="regular-14 gray_dark_02">Select Influencer</p>
				<span className="cursor-pointer" onClick={toggleIsShowFilter}>
					<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="" />
				</span>
			</div>
			<div className="form-group size36 m-0 search-filter mb-3">
				<div className="with-icon right-icon">
					<input type="text" placeholder="Search" value={search} onChange={handleSearch} />
					<span className="right-icon cursor-pointer">
						<img src="../icons/search.png" alt="" />
					</span>
				</div>
			</div>
			<div className="custom-chekbox brand-checkbox scroll-y-label">
				<div className="form-group active">
					<input
						type="checkbox"
						id="allInfluencers"
						name="allInfluencers"
						checked={
							selectedInfluencers.length > 0 &&
							selectedInfluencers.length === influencerList.length
						}
						onChange={toggleAllInfluencers}
					/>
					<label className="regular-14 gray_dark_05" htmlFor="allInfluencers">
						<span>ALL</span>
					</label>
				</div>
				{renderInfluencers()}
			</div>
		</div>
	);
};

BrandFilterLeftSidePanel.propTypes = {
	isShowFilter: bool.isRequired,
	toggleIsShowFilter: func.isRequired
};

export default BrandFilterLeftSidePanel;
